import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useParams } from 'react-router-dom';
import clsx from 'clsx';
import { useLayout } from '../core';
import { DrawerComponent } from '../../assets/ts/components';

import { AlertsFilter } from '../../../app/modules/components/filter/ethoca/alertsFilter/AlertsFilter';
import { DescriptorsFilter } from '../../../app/modules/components/filter/ethoca/descriptorsFilter/DescriptorsFilter';
import { ClientsFilter } from '../../../app/modules/components/filter/ethoca/clientsFilter/ClientsFilter';
import { EnquiriesFilter } from '../../../app/modules/components/filter/ethoca/enquiriesFilter/EnquiriesFilter';

import { UsersFilter } from '../../../app/modules/components/filter/user/usersFilter/UsersFilter';

// import { DuplicateFilter } from '../../../app/modules/components/filter/monitor/duplicateFilter/DuplicateFilter';
// import { EthocaDuplicateFilter } from '../../../app/modules/components/filter/monitor/ethocaDuplicateFilter/ethocaDuplicateFilter';
// import { RdrRecalledCaseFilter } from '../../../app/modules/components/filter/monitor/rdrRecalledCaseFilter/RdrRecalledCaseFilter';
import { AuditLogsFilter } from '../../../app/modules/components/filter/ethoca/auditLogsFilter/AuditLogsFilter';

import { CasesFilter as RdrCasesFilter } from '../../../app/modules/components/filter/verifi/casesFilter/CasesFilter';
import { ClientsFilter as RdrClientsFilter } from '../../../app/modules/components/filter/verifi/clientsFilter/ClientsFilter';
import { CaidsFilter as RdrCaidsFilter } from '../../../app/modules/components/filter/verifi/caidsFilter/CaidsFilter';

// import { ClientsFilter as BeceiptClientsFilter } from '../../../app/modules/components/filter/beceipt/clientsFilter/ClientsFilter';
import { TransactionsFilter } from '../../../app/modules/components/filter/beceipt/transactionsFilter/TransactionsFilter';
import { RequestsFilter as BeceiptRequestsFilter } from '../../../app/modules/components/filter/beceipt/requestsFilter/RequestsFilter';
// import { EmailsFilter as BeceiptEmailsFilter } from '../../../app/modules/components/filter/beceipt/emailsFilter/EmailsFilter';

// import { DuplicateArnFilter } from '../../../app/modules/components/filter/settlement/duplicateArn/DuplicateArnFilter';
// import { RdrRecalledCaseFilter } from '../../../app/modules/components/filter/settlement/rdrRecalledCaseFilter/RdrRecalledCaseFilter';
// import { ClientsFilter as StatisticClientsFilter } from '../../../app/modules/components/filter/settlement/clientsFilter/ClientsFilter';
import { LookupsFilter } from '../../../app/modules/components/filter/oiFilter/lookupsFilter/LookupsFilter';
import { OiCaidsFilter } from '../../../app/modules/components/filter/oiFilter/oiCaidsFilter/OiCaidsFilter';

import { AmlIndividualFilter } from '../../../app/modules/components/filter/shuftiPro/amlIndividual/AmlIndividualFilter';
import { AmlBusinessFilter } from '../../../app/modules/components/filter/shuftiPro/amlBusiness/AmlBusinessFilter';
import { ShuftiClientsFilter } from '../../../app/modules/components/filter/shuftiPro/clientsFilter/ClientsFilter';
import { DocumentFilter } from '../../../app/modules/components/filter/shuftiPro/documentFilter/DocumentFilter';

import { SiteFilter } from '../../../app/modules/components/filter/siteIntelligence/site/SiteFilter';
import { SiFilter } from '../../../app/modules/components/filter/siteIntelligence/si/SiFilter';
import { SiBySiteFilter } from '../../../app/modules/components/filter/siteIntelligence/si/SiBySiteFilter';
import { KeywordFilter } from '../../../app/modules/components/filter/siteIntelligence/keyword/KeywordFilter';
import { KeywordExtractionFilter } from '../../../app/modules/components/filter/siteIntelligence/keywordExtraction/KeywordExtractionFilter';
import { BrandFilter } from '../../../app/modules/components/filter/siteIntelligence/brand/BrandFilter';
import { ScheduleFilter } from '../../../app/modules/components/filter/siteIntelligence/schedule/ScheduleFilter';
import { SiteIntelligenceClientsFilter } from '../../../app/modules/components/filter/siteIntelligence/clientsFilter/ClientsFilter';
import { RemarkOptionFilter } from '../../../app/modules/components/filter/siteIntelligence/remarkOption/RemarkOptionFilter';
import { ReviewHistoryFilter } from '../../../app/modules/components/filter/siteIntelligence/reviewHistory/ReviewHistoryFilter';

import { SitesFilter as TldSitesFilter } from '../../../app/modules/components/filter/tld/sitesFilter/SitesFilter';
import { ReportsFilter as TldReportsFilter } from '../../../app/modules/components/filter/tld/reportsFilter/ReportsFilter';
import { TransactionsFilter as TldTransactionsFilter } from '../../../app/modules/components/filter/tld/transactionsFilter/TransactionsFilter';
import { ClientsFilter as TldClientsFilter } from '../../../app/modules/components/filter/tld/clientsFilter/ClientsFilter';
import { QuotasFilter as TldQuotaFilter } from '../../../app/modules/components/filter/tld/quotasFilter/QuotasFilter';
import { RemarkOptionsFilter as TldRemarkOptionsFilter } from '../../../app/modules/components/filter/tld/remarkOptionsFilter/RemarkOptionsFilter';
import { ReviewsFilter as TldReviewsFilter } from '../../../app/modules/components/filter/tld/reviewsFilter/ReviewsFilter';
import { ReviewReportsFilter as TldReviewReportsFilter } from '../../../app/modules/components/filter/tld/reviewReportsFilter/ReviewReportsFilter';
import { AuditLogsFilter as TldAuditLogsFilter } from '../../../app/modules/components/filter/tld/auditLogsFilter/AuditLogsFilter';

import { CdrnClientsFilter } from '../../../app/modules/components/filter/cdrn/clientsFilter/ClientsFilter';
import { CdrnDescriptorsFilter } from '../../../app/modules/components/filter/cdrn/descriptorsFilter/CdrnDescriptorsFilter';
import { CdrnCaseFilter } from '../../../app/modules/components/filter/cdrn/caseFilter/CaseFilter';
import { CreditFilter } from '../../../app/modules/components/filter/ethoca/creditFilter/creditFilter';

const Content: React.FC = ({ children }) => {
  const { classes } = useLayout();
  const location = useLocation();
  const params = useParams();
  const path = params['*'];

  useEffect(() => {
    DrawerComponent.hideAll();
  }, [location]);
  return (
    <div id='kt_content_container' className={clsx(classes.contentContainer.join(' '))}>
      <div>
        {path == 'ethoca/alerts/list' ? <AlertsFilter /> : ''}
        {path == 'ethoca/descriptors/list' ? <DescriptorsFilter /> : ''}
        {path == 'ethoca/clients/list' || path == 'ethoca/clients/tree' ? <ClientsFilter /> : ''}
        {path == 'ethoca/enquiries/list' ? <EnquiriesFilter /> : ''}
        {/* {path == 'ethoca/users/list' ? <UsersFilter /> : ''} */}
        {/* {path == 'ethoca/audit-logs/list' ? <AuditLogsFilter /> : ''} */}
        {path == 'ethoca/credits/list' ? <CreditFilter /> : ''}
        
        {path == 'rdr/cases/list' ? <RdrCasesFilter /> : ''}
        {path == 'rdr/clients/list' ? <RdrClientsFilter /> : ''}
        {path == 'rdr/caids/list' ? <RdrCaidsFilter /> : ''}

        {path == 'beceipt/transactions/list' ? <TransactionsFilter /> : ''}
        {/* {path == 'beceipt/clients/list' ? <BeceiptClientsFilter /> : ''} */}
        {path == 'beceipt/requests/list' ? <BeceiptRequestsFilter /> : ''}
        {/* {path == 'beceipt/failed-emails/list' ? <BeceiptEmailsFilter /> : ''} */}

        {path == 'oi/lookups/list' ? <LookupsFilter /> : ''}
        {path == 'oi/caids/list' ? <OiCaidsFilter /> : ''}

        {path == 'aml/individual-screening/list' ? <AmlIndividualFilter /> : ''}
        {path == 'aml/business-screening/list' ? <AmlBusinessFilter /> : ''}
        {path == 'aml/document-verification/list' ? <DocumentFilter /> : ''}
        {path == 'aml/clients/list' ? <ShuftiClientsFilter /> : ''}

        {/* {path == 'site-inspect/sites/list' ? <SiteFilter /> : ''} */}
        {path == 'site-inspect/reports/list' ? <SiFilter /> : ''}
        {/* {path == 'site-inspect/company-info-related/list' ? <SiBySiteFilter /> : ''} */}
        {/* {path == 'site-inspect/keywords/list' ? <KeywordFilter /> : ''} */}
        {/* {path == 'site-inspect/keywords/extracted/list' ? <KeywordExtractionFilter /> : ''} */}
        {/* {path == 'site-inspect/brands/list' ? <BrandFilter /> : ''} */}
        {path == 'site-inspect/schedules/list' ? <ScheduleFilter /> : ''}
        {path == 'site-inspect/clients/list' ? <SiteIntelligenceClientsFilter /> : ''}
        {path == 'site-inspect/remarks/list' ? <RemarkOptionFilter /> : ''}
        {path == 'site-inspect/reviews/history/list' ? <ReviewHistoryFilter /> : ''}

        {path == 'tld/sites/list' ? <TldSitesFilter /> : ''}
        {path == 'tld/reports/list' ? <TldReportsFilter /> : ''}
        {/* {path == 'tld/transactions/list' ? <TldTransactionsFilter /> : ''} */}
        {/* {path == 'tld/clients/list' ? <TldClientsFilter /> : ''} */}
        {/* {path == 'tld/quotas/list' ? <TldQuotaFilter /> : ''} */}
        {/* {path == 'tld/remarks/list' ? <TldRemarkOptionsFilter /> : ''} */}
        {/* {path == 'tld/reviews/list' ? <TldReviewsFilter /> : ''}
        {path == 'tld/review-reports/list' ? <TldReviewReportsFilter /> : ''} */}
        {/* {path == 'tld/audit-logs/list' ? <TldAuditLogsFilter /> : ''} */}

        {path == 'cdrn/clients/list' ? <CdrnClientsFilter /> : ''}
        {path == 'cdrn/descriptors/list' ? <CdrnDescriptorsFilter /> : ''}
        {path == 'cdrn/cases/list' ? <CdrnCaseFilter /> : ''}
        
        {/* {path == 'users/list' ? <UsersFilter /> : ''}
        
        {path == 'monitor/duplicate/list' ? <DuplicateFilter /> : ''}
        {path == 'monitor/duplicate-ethoca/list' ? <EthocaDuplicateFilter /> : ''}

        {path == 'settlement/duplicate-arn/list' ? <DuplicateArnFilter /> : ''}
        {path == 'settlement/recall-rdr/list' ? <RdrRecalledCaseFilter /> : ''}
        {path == 'settlement/clients/list' ? <StatisticClientsFilter /> : ''} */}
      </div>
      <div>{children}</div>
    </div>
  );
};

export { Content };
